module.exports = __webpack_public_path__ + "static/media/coreteam02.361236cb.png";